'use strict';var _typeof=require("@babel/runtime/helpers/typeof");function _interopDefault(ex){return ex&&_typeof(ex)==='object'&&'default'in ex?ex['default']:ex;}var firebase=_interopDefault(require('@firebase/app'));var name="firebase";var version="7.16.0";/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */firebase.registerVersion(name,version,'app');module.exports=firebase;